import React, { useState, useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddCountry = () => {
  const [statuses, setStatuses] = useState(['']);
  const [formData, setFormData] = useState({
    country_name: 'United Kingdom of Great Britain and Northern Ireland',
    country_code: 'GB',
    monthly_living_cost: '',
    visa_requirement: '',
    part_time_work_details: '',
    country_benefits: '',
    step_1: '',
    step_2: '',
    step_3: ''
  });
  const [loading, setLoading] = useState(false);

  const handleAddStatus = () => {
    setStatuses([...statuses, '']);
  };

  const handleStatusChange = (index, value) => {
    const updatedStatuses = [...statuses];
    updatedStatuses[index] = value;
    setStatuses(updatedStatuses);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCountryChange = (e) => {
    const selectedCode = e.target.value;
    const selectedCountry = countries.find(c => c.code === selectedCode);
    
    setFormData({
      ...formData,
      country_name: selectedCountry.name,
      country_code: selectedCountry.code
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Combine all steps into one array
      const allSteps = [
        formData.step_1,
        formData.step_2,
        formData.step_3,
        ...statuses
      ];

      // Clean and remove duplicates
       const cleanedSteps = [...new Set(allSteps.map(step => step.trim()).filter(Boolean))];

      const payload = {
        country_name: formData.country_name,
        country_code: formData.country_code,
        monthly_living_cost: formData.monthly_living_cost,
        visa_requirement: formData.visa_requirement,
        part_time_work_details: formData.part_time_work_details,
        country_benefits: formData.country_benefits,
        application_steps: cleanedSteps.join(', ')
      };

      const response = await axios.post('https://bmrbackend.dynastymaker.com/api/countries', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    toast.success('Country added successfully!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    
     // Reset form after submission
      setFormData({
        country_name: 'United Kingdom of Great Britain and Northern Ireland',
        country_code: 'GB',
        monthly_living_cost: '',
        visa_requirement: '',
        part_time_work_details: '',
        country_benefits: '',
        step_1: '',
        step_2: '',
        step_3: ''
      });
      setStatuses(['']);
  } catch (error) {
    console.error('Error adding country:', error);
    toast.error(error.response?.data?.message || 'Failed to add country', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } finally {
    setLoading(false);
  }
     

  };

const countries = [
  { "name": "Afghanistan", "code": "AF" },
  { "name": "Åland Islands", "code": "AX" },
  { "name": "Albania", "code": "AL" },
  { "name": "Algeria", "code": "DZ" },
  { "name": "American Samoa", "code": "AS" },
  { "name": "Andorra", "code": "AD" },
  { "name": "Angola", "code": "AO" },
  { "name": "Anguilla", "code": "AI" },
  { "name": "Antarctica", "code": "AQ" },
  { "name": "Antigua and Barbuda", "code": "AG" },
  { "name": "Argentina", "code": "AR" },
  { "name": "Armenia", "code": "AM" },
  { "name": "Aruba", "code": "AW" },
  { "name": "Australia", "code": "AU" },
  { "name": "Austria", "code": "AT" },
  { "name": "Azerbaijan", "code": "AZ" },
  { "name": "Bahamas", "code": "BS" },
  { "name": "Bahrain", "code": "BH" },
  { "name": "Bangladesh", "code": "BD" },
  { "name": "Barbados", "code": "BB" },
  { "name": "Belarus", "code": "BY" },
  { "name": "Belgium", "code": "BE" },
  { "name": "Belize", "code": "BZ" },
  { "name": "Benin", "code": "BJ" },
  { "name": "Bermuda", "code": "BM" },
  { "name": "Bhutan", "code": "BT" },
  { "name": "Bolivia (Plurinational State of)", "code": "BO" },
  { "name": "Bonaire, Sint Eustatius and Saba", "code": "BQ" },
  { "name": "Bosnia and Herzegovina", "code": "BA" },
  { "name": "Botswana", "code": "BW" },
  { "name": "Bouvet Island", "code": "BV" },
  { "name": "Brazil", "code": "BR" },
  { "name": "British Indian Ocean Territory", "code": "IO" },
  { "name": "Brunei Darussalam", "code": "BN" },
  { "name": "Bulgaria", "code": "BG" },
  { "name": "Burkina Faso", "code": "BF" },
  { "name": "Burundi", "code": "BI" },
  { "name": "Cabo Verde", "code": "CV" },
  { "name": "Cambodia", "code": "KH" },
  { "name": "Cameroon", "code": "CM" },
  { "name": "Canada", "code": "CA" },
  { "name": "Cayman Islands", "code": "KY" },
  { "name": "Central African Republic", "code": "CF" },
  { "name": "Chad", "code": "TD" },
  { "name": "Chile", "code": "CL" },
  { "name": "China", "code": "CN" },
  { "name": "Christmas Island", "code": "CX" },
  { "name": "Cocos (Keeling) Islands", "code": "CC" },
  { "name": "Colombia", "code": "CO" },
  { "name": "Comoros", "code": "KM" },
  { "name": "Congo", "code": "CG" },
  { "name": "Congo (Democratic Republic of the)", "code": "CD" },
  { "name": "Cook Islands", "code": "CK" },
  { "name": "Costa Rica", "code": "CR" },
  { "name": "Côte d'Ivoire", "code": "CI" },
  { "name": "Croatia", "code": "HR" },
  { "name": "Cuba", "code": "CU" },
  { "name": "Curaçao", "code": "CW" },
  { "name": "Cyprus", "code": "CY" },
  { "name": "Czech Republic", "code": "CZ" },
  { "name": "Denmark", "code": "DK" },
  { "name": "Djibouti", "code": "DJ" },
  { "name": "Dominica", "code": "DM" },
  { "name": "Dominican Republic", "code": "DO" },
  { "name": "Ecuador", "code": "EC" },
  { "name": "Egypt", "code": "EG" },
  { "name": "El Salvador", "code": "SV" },
  { "name": "Equatorial Guinea", "code": "GQ" },
  { "name": "Eritrea", "code": "ER" },
  { "name": "Estonia", "code": "EE" },
  { "name": "Eswatini", "code": "SZ" },
  { "name": "Ethiopia", "code": "ET" },
  { "name": "Falkland Islands (Malvinas)", "code": "FK" },
  { "name": "Faroe Islands", "code": "FO" },
  { "name": "Fiji", "code": "FJ" },
  { "name": "Finland", "code": "FI" },
  { "name": "France", "code": "FR" },
  { "name": "French Guiana", "code": "GF" },
  { "name": "French Polynesia", "code": "PF" },
  { "name": "French Southern Territories", "code": "TF" },
  { "name": "Gabon", "code": "GA" },
  { "name": "Gambia", "code": "GM" },
  { "name": "Georgia", "code": "GE" },
  { "name": "Germany", "code": "DE" },
  { "name": "Ghana", "code": "GH" },
  { "name": "Gibraltar", "code": "GI" },
  { "name": "Greece", "code": "GR" },
  { "name": "Greenland", "code": "GL" },
  { "name": "Grenada", "code": "GD" },
  { "name": "Guadeloupe", "code": "GP" },
  { "name": "Guam", "code": "GU" },
  { "name": "Guatemala", "code": "GT" },
  { "name": "Guernsey", "code": "GG" },
  { "name": "Guinea", "code": "GN" },
  { "name": "Guinea-Bissau", "code": "GW" },
  { "name": "Guyana", "code": "GY" },
  { "name": "Haiti", "code": "HT" },
  { "name": "Heard Island and McDonald Islands", "code": "HM" },
  { "name": "Holy See", "code": "VA" },
  { "name": "Honduras", "code": "HN" },
  { "name": "Hong Kong", "code": "HK" },
  { "name": "Hungary", "code": "HU" },
  { "name": "Iceland", "code": "IS" },
  { "name": "India", "code": "IN" },
  { "name": "Indonesia", "code": "ID" },
  { "name": "Iran (Islamic Republic of)", "code": "IR" },
  { "name": "Iraq", "code": "IQ" },
  { "name": "Ireland", "code": "IE" },
  { "name": "Isle of Man", "code": "IM" },
  { "name": "Israel", "code": "IL" },
  { "name": "Italy", "code": "IT" },
  { "name": "Jamaica", "code": "JM" },
  { "name": "Japan", "code": "JP" },
  { "name": "Jersey", "code": "JE" },
  { "name": "Jordan", "code": "JO" },
  { "name": "Kazakhstan", "code": "KZ" },
  { "name": "Kenya", "code": "KE" },
  { "name": "Kiribati", "code": "KI" },
  { "name": "Korea (Democratic People's Republic of)", "code": "KP" },
  { "name": "Korea (Republic of)", "code": "KR" },
  { "name": "Kuwait", "code": "KW" },
  { "name": "Kyrgyzstan", "code": "KG" },
  { "name": "Lao People's Democratic Republic", "code": "LA" },
  { "name": "Latvia", "code": "LV" },
  { "name": "Lebanon", "code": "LB" },
  { "name": "Lesotho", "code": "LS" },
  { "name": "Liberia", "code": "LR" },
  { "name": "Libya", "code": "LY" },
  { "name": "Liechtenstein", "code": "LI" },
  { "name": "Lithuania", "code": "LT" },
  { "name": "Luxembourg", "code": "LU" },
  { "name": "Macao", "code": "MO" },
  { "name": "Madagascar", "code": "MG" },
  { "name": "Malawi", "code": "MW" },
  { "name": "Malaysia", "code": "MY" },
  { "name": "Maldives", "code": "MV" },
  { "name": "Mali", "code": "ML" },
  { "name": "Malta", "code": "MT" },
  { "name": "Marshall Islands", "code": "MH" },
  { "name": "Martinique", "code": "MQ" },
  { "name": "Mauritania", "code": "MR" },
  { "name": "Mauritius", "code": "MU" },
  { "name": "Mayotte", "code": "YT" },
  { "name": "Mexico", "code": "MX" },
  { "name": "Micronesia (Federated States of)", "code": "FM" },
  { "name": "Moldova (Republic of)", "code": "MD" },
  { "name": "Monaco", "code": "MC" },
  { "name": "Mongolia", "code": "MN" },
  { "name": "Montenegro", "code": "ME" },
  { "name": "Montserrat", "code": "MS" },
  { "name": "Morocco", "code": "MA" },
  { "name": "Mozambique", "code": "MZ" },
  { "name": "Myanmar", "code": "MM" },
  { "name": "Namibia", "code": "NA" },
  { "name": "Nauru", "code": "NR" },
  { "name": "Nepal", "code": "NP" },
  { "name": "Netherlands", "code": "NL" },
  { "name": "New Caledonia", "code": "NC" },
  { "name": "New Zealand", "code": "NZ" },
  { "name": "Nicaragua", "code": "NI" },
  { "name": "Niger", "code": "NE" },
  { "name": "Nigeria", "code": "NG" },
  { "name": "Niue", "code": "NU" },
  { "name": "Norfolk Island", "code": "NF" },
  { "name": "North Macedonia", "code": "MK" },
  { "name": "Northern Mariana Islands", "code": "MP" },
  { "name": "Norway", "code": "NO" },
  { "name": "Oman", "code": "OM" },
  { "name": "Pakistan", "code": "PK" },
  { "name": "Palau", "code": "PW" },
  { "name": "Palestine, State of", "code": "PS" },
  { "name": "Panama", "code": "PA" },
  { "name": "Papua New Guinea", "code": "PG" },
  { "name": "Paraguay", "code": "PY" },
  { "name": "Peru", "code": "PE" },
  { "name": "Philippines", "code": "PH" },
  { "name": "Pitcairn", "code": "PN" },
  { "name": "Poland", "code": "PL" },
  { "name": "Portugal", "code": "PT" },
  { "name": "Puerto Rico", "code": "PR" },
  { "name": "Qatar", "code": "QA" },
  { "name": "Réunion", "code": "RE" },
  { "name": "Romania", "code": "RO" },
  { "name": "Russian Federation", "code": "RU" },
  { "name": "Rwanda", "code": "RW" },
  { "name": "Saint Barthélemy", "code": "BL" },
  { "name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH" },
  { "name": "Saint Kitts and Nevis", "code": "KN" },
  { "name": "Saint Lucia", "code": "LC" },
  { "name": "Saint Martin (French part)", "code": "MF" },
  { "name": "Saint Pierre and Miquelon", "code": "PM" },
  { "name": "Saint Vincent and the Grenadines", "code": "VC" },
  { "name": "Samoa", "code": "WS" },
  { "name": "San Marino", "code": "SM" },
  { "name": "Sao Tome and Principe", "code": "ST" },
  { "name": "Saudi Arabia", "code": "SA" },
  { "name": "Senegal", "code": "SN" },
  { "name": "Serbia", "code": "RS" },
  { "name": "Seychelles", "code": "SC" },
  { "name": "Sierra Leone", "code": "SL" },
  { "name": "Singapore", "code": "SG" },
  { "name": "Sint Maarten (Dutch part)", "code": "SX" },
  { "name": "Slovakia", "code": "SK" },
  { "name": "Slovenia", "code": "SI" },
  { "name": "Solomon Islands", "code": "SB" },
  { "name": "Somalia", "code": "SO" },
  { "name": "South Africa", "code": "ZA" },
  { "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
  { "name": "South Sudan", "code": "SS" },
  { "name": "Spain", "code": "ES" },
  { "name": "Sri Lanka", "code": "LK" },
  { "name": "Sudan", "code": "SD" },
  { "name": "Suriname", "code": "SR" },
  { "name": "Svalbard and Jan Mayen", "code": "SJ" },
  { "name": "Sweden", "code": "SE" },
  { "name": "Switzerland", "code": "CH" },
  { "name": "Syrian Arab Republic", "code": "SY" },
  { "name": "Taiwan", "code": "TW" },
  { "name": "Tajikistan", "code": "TJ" },
  { "name": "Tanzania, United Republic of", "code": "TZ" },
  { "name": "Thailand", "code": "TH" },
  { "name": "Timor-Leste", "code": "TL" },
  { "name": "Togo", "code": "TG" },
  { "name": "Tokelau", "code": "TK" },
  { "name": "Tonga", "code": "TO" },
  { "name": "Trinidad and Tobago", "code": "TT" },
  { "name": "Tunisia", "code": "TN" },
  { "name": "Turkey", "code": "TR" },
  { "name": "Turkmenistan", "code": "TM" },
  { "name": "Turks and Caicos Islands", "code": "TC" },
  { "name": "Tuvalu", "code": "TV" },
  { "name": "Uganda", "code": "UG" },
  { "name": "Ukraine", "code": "UA" },
  { "name": "United Arab Emirates", "code": "AE" },
  { "name": "United Kingdom of Great Britain and Northern Ireland", "code": "GB" },
  { "name": "United States of America", "code": "US" },
  { "name": "United States Minor Outlying Islands", "code": "UM" },
  { "name": "Uruguay", "code": "UY" },
  { "name": "Uzbekistan", "code": "UZ" },
  { "name": "Vanuatu", "code": "VU" },
  { "name": "Venezuela (Bolivarian Republic of)", "code": "VE" },
  { "name": "Viet Nam", "code": "VN" },
  { "name": "Virgin Islands (British)", "code": "VG" },
  { "name": "Virgin Islands (U.S.)", "code": "VI" },
  { "name": "Wallis and Futuna", "code": "WF" },
  { "name": "Western Sahara", "code": "EH" },
  { "name": "Yemen", "code": "YE" },
  { "name": "Zambia", "code": "ZM" },
  { "name": "Zimbabwe", "code": "ZW" }
];

  const [selectedCode, setSelectedCode] = useState('BE');

  const handleChange = (e) => {
    setSelectedCode(e.target.value);
  };

  const selectedCountry = countries.find((c) => c.code === selectedCode);


  return (
   <div className="container py-4">
      {/* Add Country Section */}
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          Add Country
        </div>
      </div>
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <div className="mb-3">
            <label>Country Name</label>
            <div className='border px-2 rounded' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img
                src={`https://flagsapi.com/${formData.country_code}/flat/32.png`}
                alt="flag"
                style={{ width: '32px', height: '24px' }}
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = 'https://flagsapi.com/US/flat/32.png';
                }}
              />
              <select
                className="form-select border-0 no-border-select"
                name="country_code"
                value={formData.country_code}
                onChange={handleCountryChange}
              >
                <option value="" disabled>Select a country</option>
                {countries.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* Rest of your form fields */}
          <div className="mb-3">
            <label>Monthly Living Cost</label>
            <input 
              type="text" 
              className="form-control" 
              name="monthly_living_cost"
              value={formData.monthly_living_cost}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label>Visa Requirement</label>
            <input 
              type="text" 
              className="form-control" 
              name="visa_requirement"
              value={formData.visa_requirement}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label>Part Time Work Details</label>
            <input 
              type="text" 
              className="form-control" 
              name="part_time_work_details"
              value={formData.part_time_work_details}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label>Country Benefits</label>
            <input 
              type="text" 
              className="form-control" 
              name="country_benefits"
              value={formData.country_benefits}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>

      {/* Add Application Process Section */}
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          Add Application Process
        </div>
      </div>
      
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Step 01</label>
              <input 
                type="text" 
                className="form-control" 
                name="step_1"
                value={formData.step_1}
                onChange={handleInputChange}
              />
              <label>Step 02</label>
              <input 
                type="text" 
                className="form-control" 
                name="step_2"
                value={formData.step_2}
                onChange={handleInputChange}
              />
              <label>Step 03</label>
              <input 
                type="text" 
                className="form-control" 
                name="step_3"
                value={formData.step_3}
                onChange={handleInputChange}
              />
            </div>

            {statuses.map((status, index) => (
              <div className="mb-3" key={index}>
                <label>Status 0{index + 4}</label>
                <input
                  type="text"
                  className="form-control"
                  value={status}
                  onChange={(e) => handleStatusChange(index, e.target.value)}
                />
              </div>
            ))}

            <div className="d-flex justify-content-end mb-3">
              <button 
                type="button" 
                style={{width:'35px', height:'35px' }} 
                className="btn buttonadd d-flex align-items-center justify-content-center text-primary rounded-circle" 
                onClick={handleAddStatus}
              >
                <FaPlus size={20} />
              </button>
            </div>

            <div className="d-flex gap-2 pt-3 pb-3">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit'}
              </button>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={() => {
                  setStatuses(['']);
                  setFormData({
                    country_name: 'United Kingdom of Great Britain and Northern Ireland',
                    country_code: 'GB',
                    monthly_living_cost: '',
                    visa_requirement: '',
                    part_time_work_details: '',
                    country_benefits: '',
                    step_1: '',
                    step_2: '',
                    step_3: ''
                  });
                }}
              >
                Clear
              </button>
            </div>

            <div className="mt-3">
              <Link to={'/super-admin/country'} type="button" className="btn bg-light buttonadd">
                <IoArrowUndoSharp size={20} /> Back
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCountry;